import { ApiError, request } from "@/api/request";

// SEC-CD-10 / B-4 / SEC-CD-P1-21 — the console's single mutation entry point
// (useControlStore.applyMode is its only caller). Captured once at module
// load so the check can never be affected by a later, per-call read.
const WATCHER_BASE_URL = import.meta.env.VITE_WATCHER_BASE_URL;

/**
 * mutate — accepts only the Watcher base URL and throws synchronously,
 * before any network call, for any other origin.
 */
export async function mutate<T>(baseUrl: string, path: string, body: unknown): Promise<T> {
  if (baseUrl !== WATCHER_BASE_URL) {
    throw new Error("mutate() may only target the Watcher base URL (SEC-CD-10)");
  }

  const result = await request<T>(baseUrl, path, {
    method: "POST",
    body,
    recognizeApplicationRefusal: true,
  });

  if (result === null) {
    throw new ApiError("Malformed response");
  }
  return result;
}
